import MetabaseAnalyticsCard from "components/Templates/MetabaseAnalyticsCard"
import React from "react"

const StockTakeAnalyticsPage = () => {
  return (
    <div className="p-3">
      <MetabaseAnalyticsCard filter={{ dashboard: 22 }} />
    </div>
  )
}

export default StockTakeAnalyticsPage
